import CSS from "./static/css/Cross.module.css";

const Cross = () => {
    return(
        <div className={CSS.l_Cross_main} />
    )
}

export default Cross;